import { useState, useEffect } from "react";
import "../Styles/Stats.css";
import { useConfig } from "../../context/ConfigContext";

export default function StatsTab() {
  const { config } = useConfig();
  const statsUrl = config.REACT_APP_STATS_URL;
  const apiKey = config.REACT_APP_API_KEY;
  const getDonUrl = config.REACT_APP_API_URL;

  const [stats, setStats] = useState(null);
  const [don, setDon] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = async () => {
    setLoading(true);
    try {
      const sRes = await fetch(statsUrl, { headers: { "Api-Key": apiKey } });
      const dRes = await fetch(getDonUrl, { headers: { "Api-Key": apiKey } });

      const sData = await sRes.json().catch(() => ({}));
      const dData = await dRes.json().catch(() => ({}));

      setStats(sData || {});
      setDon(Number(dData?.donated?.amountDonated) || 0);
    } catch (e) {
      console.log(e);
      setStats({ error: true });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Format uptime into hours/minutes/seconds
  const formatUptime = (seconds) => {
    if (!seconds) return "—";
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return `${h}h ${m}m ${s}s`;
  };

  /*// Format a YYYY-MM-DD into nicer text
  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-UK", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  };*/

  return (
    <div className="card-grid">
      <section className="card">
        <h2>📈 Site Statistics</h2>

        <div className="stats-grid">
          <div className="stat">
            <span>Visits Today</span>
            <strong>{stats?.visitsToday ?? "—"}</strong>
          </div>

          <div className="stat">
            <span>Total Visits</span>
            <strong>{stats?.totalVisits ?? "—"}</strong>
          </div>

          <div className="stat">
            <span>Donation Total</span>
            <strong>{don !== null ? `£${don.toLocaleString()}` : "—"}</strong>
          </div>

          <div className="stat">
            <span>Gallery Total</span>
            <strong>{stats?.galleryCount ?? "—"}</strong>
          </div>

          <div className="stat">
            <span>Uptime</span>
            <strong>{formatUptime(stats?.uptimeSeconds)}</strong>
          </div>

          <div className="stat">
            <span>API Status</span>
            <strong>{stats?.apiStatus ?? "—"}</strong>
          </div>
        </div>

        {/* LAST 14 DAYS TRAFFIC */}
        {/* LAST 14 DAYS — BAR CHART */}
{stats?.visitHistory && (
  <div className="daily-chart">
    <h3>📅 Last 14 Days Traffic</h3>

    <div className="chart-wrapper">
      {stats.visitHistory.map((day) => (
        <div className="chart-bar-group" key={day.date}>
          <div
            className="chart-bar"
            style={{
              height: `${Math.max(day.count, 2) * 4}px` // scale multiplier
            }}
          ></div>
          <span className="chart-label">
            {new Date(day.date).toLocaleDateString("en-UK", {
              weekday: "short"
            })}
          </span>
          <span className="chart-value">{day.count}</span>
        </div>
      ))}
    </div>
  </div>
)}


        <div className="actions">
          <button
            className="btn ghost"
            onClick={refresh}
            disabled={loading}
          >
            {loading ? "Refreshing…" : "Refresh"}
          </button>
        </div>
      </section>
    </div>
  );
}